import {
  ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__REQUEST,
  ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS,
  ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__REQUEST:
    case ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS: {
      return null;
    }

    case ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
